// Elenco delle news
import React from 'react';
import { get } from './Storage';
import axios from 'axios';
import RaisedButton from 'material-ui/RaisedButton';
import * as Colors from 'material-ui/styles/colors';
import CircularProgress from 'material-ui/CircularProgress';
import { Card, CardHeader, CardText } from 'material-ui/Card';
import { Message } from "mgUiKit";
import KeepAlive from './KeepAlive';
import DepositToolsPage from './Page/DepositTools';
import WithdrawalTools from './Page/WithdrawalTools';
import PropTypes from 'prop-types';

// Init Configuration
var AppSettings = get();
var componentName = AppSettings.appId + 'TabPanelComponent';

var styles = AppSettings.styles;

class TabPanel extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            data: {},
            error: false,
            showLoading: true,
            errorMessage: ""
        }
        this.loadTabcontrolPanel = this.loadTabcontrolPanel.bind(this);
        this.loadTabcontrolPanel = this.loadTabcontrolPanel.bind(this);

        this.socialContainerRef = React.createRef();
    }

    componentDidMount() {
        this.loadTabcontrolPanel();
    }

    loadTabcontrolPanel() {
        this.setState({
            showLoading: true,
        });
        var url = AppSettings['env'].urlUserBoxTabControlPanel;

        axios.get(url)
            .then(({ data, status, statusText }) => {
                if (data.errors.length == 0) {
                    this.setState({
                        data: data,
                        error: false,
                        showLoading: false,
                        errorMessage: ""
                    });
                } else {
                    this.setState({
                        error: true,
                        showLoading: false,
                        errorMessage: <KeepAlive />
                    });

                }
            })

            .catch(({ data, status, statusText }) => {
                this.setState({
                    error: true,
                    showLoading: false,
                    errorMessage: ""
                });
            });
    }

    renderPanel() {
        return (
            <>
              <div className="mg-user-widget">
                    {/*
                    <RaisedButton label={AppSettings.urls.deposit.text}
                        href={AppSettings.urls.deposit.href}
                        primary={true}
                        style={styles.fullWidth}
                        labelStyle={styles.labelWhite} />
                    */}
                    {/* Abilito il bottone preleva solo se l'utente connesso è un player*/}
                    {/*
                    {AppSettings['perms'].withdrawal ?

                        <RaisedButton href={AppSettings.urls.withDrawalTools.href}
                            label={AppSettings.urls.withDrawalTools.text}
                            primary={false}
                            labelStyle={styles.labelCTA}
                            style={styles.fullWidth}
                            labelColor={Colors.grey500} />


                        : null}*/}
                    {AppSettings['perms'].deposit ?
                        <DepositToolsPage />
                    : null}
                    {AppSettings['perms'].withdrawal ?
                        <WithdrawalTools />
                        : null}
                </div>
                <div className="mg-user-widget">
                    {(() => {
                        var clickEvent = (e) => {
                                this.context.openLinkPopup(e, AppSettings.urls.statementOfAccount.href);
                            }
                            return (
                                <RaisedButton 
                                    className="mg-user-widget--conto-gioco"
                                    //href={AppSettings.urls.statementOfAccount.href}
                                    label={AppSettings.urls.statementOfAccount.text}
                                    style={styles.fullWidth} labelStyle={styles.labelCTA}
                                    labelColor={Colors.grey500}
                                    onClick={clickEvent}
                                />
                            )
                    })()}
                </div>

                {(() => {
                    var internalStyle = { display: 'none' };
                    if (this.state.data.urls.length > 0) {
                        internalStyle.display = 'block';
                    }
                    var urls = this.state.data.urls.map(function (url, i) {
                        var key = url.key;
                        var clickEnvet = (e) => {
                            this.context.openLinkPopup(e, url.href);
                        }
                        var shareLinkContainer = "";
                        var urlLink = url.href;
                        if(key.toLowerCase().indexOf('sharelink') != -1){
                            urlLink = '#';
                            shareLinkContainer = <div ref={this.socialContainerRef} id="ub-share-link"></div>;
                            var self = this;
                            clickEnvet = (e) => {
                                // self.socialContainerRef.current.innerHTML = "";
                                // var shareBet = new Share(document.getElementById("ub-share-link"), {
                                //     facebook: true,
                                //     twitter: true,
                                //     print: false,
                                //     whatsappweb: AppSettings.device != "mobile",
                                //     whatsapp: true,
                                //     email: true,
                                //     telegram: true,
                                //     subjectText: "Oggetto del messaggio",
                                //     text: "TESTO MSF",
                                //     url: url.href,
                                //     hashtag: ""
                                // });
                            };
                            setTimeout(function(){
                                self.socialContainerRef.current.innerHTML = "";
                                var siteName = AppSettings["homeRealm"]
                                .replace("https://", "")
                                .replace("http://", "")
                                .replace("www.", "")
                                .replace("/", "")
                                .replace(".it", "");
                                var ShareLinkText = "Ciao, puoi registrarti su " + siteName + " cliccando sul seguente link";
                                var ShareLinkObject = "Registrati su " + siteName.toUpperCase();
                                
                                var shareBet = new Share(document.getElementById("ub-share-link"), {
                                    facebook: true,
                                    twitter: true,
                                    print: false,
                                    whatsappweb: AppSettings.device != "mobile",
                                    whatsapp: true,
                                    email: true,
                                    telegram: true,
                                    subjectText: ShareLinkObject,
                                    text: ShareLinkText,
                                    url: url.href,
                                    hashtag: ""
                                });
                            },500);
                            
                        }
                        
                        return (
                            <li className={url.key} key={key}><a target={url.target} title={url.title}
                                href={urlLink} onClick={clickEnvet}>{url.text}</a>
                                {shareLinkContainer}
                            </li>
                        );
                        //}
                    }.bind(this));
                    
                    return (
                        <div style={internalStyle} id="mg-ultimi-login" className="mg-user-widget">
                            <ul id="mg-panel-list">
                                {urls}
                            </ul>
                        </div>
                    )
                })()}
            </>
        );
    }

    render() {
        
        var render;
        if (this.state.showLoading) {
            render = <CircularProgress style={styles.loadingIcon} />;
        }
        else {
            if (this.state.error) {
                render = <Message align="center" type="error">{this.state.errorMessage}</Message>;
            }
            else {
                render = this.renderPanel();
            }
        }

        return render;
    }
}

TabPanel.displayName = componentName;

// PropTypes validation
TabPanel.propTypes = {};

// default props
TabPanel.defaultProps = {};


TabPanel.contextTypes = {
    openLinkPopup: PropTypes.func
}
export default  TabPanel;